import React from 'react';
import { useTheme } from '@mui/material/styles/';
import { props, defaultProps } from './entitiesIconsProps';

const EpisodeBoldIcon = ({ width, height }) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      height={height}
    >
      <path
        d="M64 32C99.35 32 128 60.65 128 96C128 131.3 99.35 160 64 160C28.65 160 0 131.3 0 96C0 60.65 28.65 32 64 32zM488 72C501.3 72 512 82.75 512 96C512 109.3 501.3 120 488 120H184C170.7 120 160 109.3 160 96C160 82.75 170.7 72 184 72H488zM488 232C501.3 232 512 242.7 512 256C512 269.3 501.3 280 488 280H184C170.7 280 160 269.3 160 256C160 242.7 170.7 232 184 232H488zM488 392C501.3 392 512 402.7 512 416C512 429.3 501.3 440 488 440H184C170.7 440 160 429.3 160 416C160 402.7 170.7 392 184 392H488zM64 192C99.35 192 128 220.7 128 256C128 291.3 99.35 320 64 320C28.65 320 0 291.3 0 256C0 220.7 28.65 192 64 192zM40 256C40 269.3 50.75 280 64 280C77.25 280 88 269.3 88 256C88 242.7 77.25 232 64 232C50.75 232 40 242.7 40 256zM64 480C28.65 480 0 451.3 0 416C0 380.7 28.65 352 64 352C99.35 352 128 380.7 128 416C128 451.3 99.35 480 64 480zM88 416C88 402.7 77.25 392 64 392C50.75 392 40 402.7 40 416C40 429.3 50.75 440 64 440C77.25 440 88 429.3 88 416z"
        fill={theme.palette.secondary.main}
      />
    </svg>
  );
};

EpisodeBoldIcon.propTypes = props;

EpisodeBoldIcon.defaultProps = defaultProps;

export default EpisodeBoldIcon;
